import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lessonList: [],
  lessonDetail: [],
  loading: false,
  error: undefined,
};

const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchLessonList(state, action) {
      state.lessonList = action.payload;
      state.loading = false;
    },
    fetchLessonDetail(state, action) {
      state.lessonDetail = action.payload;
      state.loading = false;
    },
  },
});

export const lessonActions = lessonSlice.actions;

export default lessonSlice.reducer;
